import React, { useEffect, useState } from "react";
import { View, StyleSheet, ActivityIndicator, Modal } from "react-native";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { selectIsLogged } from "../../store/auth/authReducer";
import RootNavigator, { RootStackParamList } from "../navigator";
import LoginModal from "./Modals/LoginModal";
import LoginScreen from "../screens/LoginScreen";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
type LoginIdentity = "username" | "phone";
type LoginAlert = { type: "error" | "success"; message: string };
type Props = NativeStackScreenProps<RootStackParamList, "Login">;

const AuthGate: React.FC<Props> = ({ navigation }) => {
  const isLogged = useSelector(selectIsLogged);
  const authLoading = useSelector((s: RootState) => s.auth.loading);
  const authToken = useSelector((s: RootState) => s.auth.token);
  const authError = useSelector((s: RootState) => s.auth.error);
  const authIsLoggedState = useSelector((s: RootState) => s.auth.isLogged);
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    const { isTokenExpired } = require("../../utils/helpers/tokenUtils");
    console.log("[AuthGate.native] State update:", {
      isLogged,
      authLoading,
      hasToken: !!authToken,
      authError,
      authIsLoggedState,
      tokenExpired: authToken ? isTokenExpired(authToken) : "no token",
      modalVisible: !isLogged,
    });
  }, [isLogged, authLoading, authToken, authError, authIsLoggedState]);
  const [identity, setIdentity] = useState<LoginIdentity>("username");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    username: "",
    mobileNumber: "",
    password: "",
  });
  const [errors, setErrors] = useState<{
    username?: string;
    mobileNumber?: string;
    password?: string;
  }>({});

  const onChange = (name: keyof typeof data, value: string) =>
    setData((d) => ({ ...d, [name]: value }));

  const onSave = () => {
    // validate / submit here if you want
    setLoading(true);
    // example/end: setLoading(false)
  };

  const setAlert = (_a: LoginAlert) => {};
  const onSuccess = (_token: string) => {};

  useEffect(() => {
    if (authLoading === false) setIsInitializing(false);
  }, [authLoading]);

  return (
    <View style={{ flex: 1 }}>
      <RootNavigator />

      {/* Show login as an overlay using LoginModal (SvaraModal handles its own modal) */}
      {!isLogged && (
        <View style={styles.modalOverlay}>
          <LoginModal
            onClose={() => {
              // keep modal open while user is not logged in
            }}
            data={data}
            errors={errors}
            onSave={onSave}
            onChange={onChange}
            identity={identity}
            loading={loading}
            setIdentity={setIdentity}
            setAlert={setAlert}
            onSuccess={onSuccess}
            showCloseIcon={false}
          />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#000",
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.7)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    width: 300,
    maxWidth: "90%",
    backgroundColor: "#112345", // or transparent if LoginPage has bg
    borderRadius: 12,
    padding: 16,
  },
});

export default AuthGate;
